import { PrismicRichText } from "@prismicio/react";
import React from 'react';

export const LegalContent = (props) => {

    const sc = props.slice.primary;

    const components = {
        label: ({ children }) => (
          <sup>{children}</sup>
        ),
    }

    return (
        <section className="gutter sm teal pr">
            <div className="wrapper lg:w-3/5">
                <div className="text-teal mb-12"><PrismicRichText field={sc.section_title.richText} components={components} /></div>
                <PrismicRichText field={sc.content.richText} />
            </div>
        </section>
    );
}

